import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRightChevronGrey = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 5,
	height: 10,
	viewBox: "0 0 5 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.829712 1.5L3.90945 5L0.829712 8.5",
		stroke: "#838B95",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgRightChevronGrey;
